import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import { Button } from "../Button";
import { A11yText } from "../A11yText";

const ButtonGroupIcon = forwardRef(({ icon, children, ...props }, ref) => {
  return (
    <>
      <Button.Icon icon={icon} ref={ref} {...props} />
      {children && <A11yText>{children}</A11yText>}
    </>
  );
});

ButtonGroupIcon.propTypes = {
  icon: PropTypes.elementType.isRequired,
  children: PropTypes.string,
};

ButtonGroupIcon.defaultProps = {
  children: null,
};

ButtonGroupIcon.displayName = "ButtonGroup.Icon";

export default ButtonGroupIcon;
